const MockDelay = async (ms: number) => {
    return new Promise(async (resolve, reject) => {
      try {
        setTimeout(() => {
          resolve(true);
        }, ms);
      } catch (e) {
        reject(e);
      }
    });
  };

  export default MockDelay;
